<template>
  <!-- 单个带有续报科目的卡片，下含多个课程和商品 -->
  <!-- 此处判断样式只是为了原班推荐图标能贴边展示否则将有1像素白边 -->
  <div
    :class="[
      listType === 'change' ? 'card-tab-wrap-no-border' : 'card-tab-wrap',
    ]"
    :id="
      info && info.title_info && info.title_info.learn_course_id
        ? `learn_course_id${info.title_info.learn_course_id}`
        : ''
    "
  >
    <!-- cnt_list下的title_info作为标题部分（粉色背景标题部分） -->
    <course-tab-title
      v-if="$$(info.title_info).title"
      :title="info.title_info.title"
    ></course-tab-title>
    <div v-if="info.isEmptyCourseCard" class="empty-package-info">
      暂无老学员报名课程
    </div>
    <div v-else class="select-card-wrap">
      <!-- 多个package_info只展示一个冲突提示 -->
      <noticeBar v-if="info.isClash" :text="info.clashMsg" showBorder />
      <!-- 单选按钮部分，每一个package_info对应一个单选按钮 -->
      <select-card
        v-for="(sItem, sIndex) in this.info.package_info"
        :showNotice="info.isClash && sIndex === 0"
        :key="sIndex"
        :package_info_index="sIndex"
        :package_info="sItem"
        :must_check="$$(info.title_info).must_check === 1"
        :isLast="isLastTab && sIndex === info.package_info.length - 1"
      />
    </div>
  </div>
</template>

<script>
import courseTabTitle from "./courseTabTitle.vue";
import selectCard from "./selectCard.vue";
import noticeBar from "../../../components/noticeBar.vue";
export default {
  provide() {
    return {
      tab_list_index: this.tab_list_index, // 为了在跳转二级页的时候组装参数
      isAddPriceBuy: this.info?.isAddPriceBuy, // 是否是加价购配置的课程
      change_info: this.info?.title_info?.change_info,
      parent: this.info?.parent,
      switch_change: this.info?.title_info?.switch_change, // 加价购是否支持更换课程
    };
  },
  inject: ["listType"],
  props: {
    tab_list_index: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isLastTab: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    noticeBar,
    selectCard,
    courseTabTitle,
  },
  data() {
    return {
      showNotice: true,
    };
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.card-tab-wrap {
  .only-bg('https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/title-bg-new.png',100%,80px);
  margin-top: 8px;
  position: relative;
  // border: 1px solid #fff;
  border-radius: 16px;
  overflow: hidden;
  background-color: #fff;
}
.card-tab-wrap-no-border {
  .card-tab-wrap;
  border: none;
}
.select-card-wrap {
  //   border: 1px solid #fff;
  border-radius: 16px 16px 0 0;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
}
.empty-package-info {
  .flex-center-center;
  height: 178px;
  color: #666;
  font-family: PingFang SC;
  font-size: 13px;
  font-weight: 400;
  background-color: #fff;
}
</style>
